<template>
  <div class="createStoreProdcut">
    <div class="basic_info">
      <div class="title">{{ $t("other.a3355") }}</div>
      <div class="basic_detail">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item :label="$t('other.a66')" prop="layoutImageUrl">
            <el-upload
              class="avatar-uploader"
              :headers="token"
              action="https://erp.shopsbu.com/service/access/upload"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload"
            >
            <!-- <el-upload
              class="avatar-uploader"
              :show-file-list="false"
              :before-upload="beforeAvatarUploadDPI"
            > -->
              <img v-if="imageUrl" :src="imageUrl" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item :label="$t('other.a3356')" prop="layoutName">
            <el-input v-model="ruleForm.layoutName"></el-input>
          </el-form-item>
          <el-form-item label="版面分组" prop="groupId">
            <el-select v-model="ruleForm.groupId" filterable>
              <el-option
                v-for="item in options"
                :key="item.id"
                :label="item.groupsName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="打印位置说明"
            prop="printingPositionInstructions"
          >
            <el-input
              v-model="ruleForm.printingPositionInstructions"
            ></el-input>
          </el-form-item>
          <el-button
            style="margin-right: 60px"
            type="primary"
            @click="openMatch"
            >点击匹配实物</el-button
          >
          <el-table
            :data="ruleForm.standardPatternPrintImagesList"
            style="width: 100%"
          >
            <el-table-column prop="cusCode" label="仓库编码"> </el-table-column>
            <el-table-column prop="skuName" label="skuName"> </el-table-column>
            <el-table-column prop="variationName" label="仓库子sku">
            </el-table-column>
            <el-table-column prop="imageUrl" label="打印图片">
              <template slot-scope="scope">
                <el-upload
                  class="avatar-uploader"
                  :headers="token"
                  action="https://erp.shopsbu.com/service/access/upload"
                  :show-file-list="false"
                  :on-success="
                    (res, file) =>
                      handleSuccess(
                        ruleForm.standardPatternPrintImagesList,
                        scope.$index,
                        res,
                        file
                      )
                  "
                  :before-upload="beforeAvatarUploadDPI"
                >
                  <img
                    v-if="scope.row.imageUrl"
                    :src="scope.row.imageUrl"
                    class="avatar"
                  />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作">
              <template slot-scope="scope">
                <el-button
                  @click.native.prevent="
                    deleteRow(
                      scope.$index,
                      ruleForm.standardPatternPrintImagesList
                    )
                  "
                  type="text"
                  size="small"
                >
                  移除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form>
      </div>
    </div>

    <div class="footer">
      <div style="margin-right: 50px">
        <el-button
          style="margin-right: 60px"
          type="primary"
          @click="cancel()"
          >{{ $t("other.a106") }}</el-button
        >
        <el-button
          type="primary"
          @click="saveItem()"
          v-if="standardPatternId == ''"
          >{{ $t("other.a2773") }}</el-button
        >
        <el-button
          type="primary"
          @click="saveItem()"
          v-if="standardPatternId != '' && pathType == 'galleryStandard'"
          >{{ $t("other.a93") }}</el-button
        >
      </div>
    </div>

    <Customer-Order
      :showMatchCopy.sync="showMatch"
      :mathListCopy.sync="mathList"
      textDesc="匹配实物产品"
      @updataItem="updataItem"
    ></Customer-Order>
  </div>
</template>
  
<script>
import CustomerOrder from "../allOrders/pendingorder/components/dialog.vue";
import galleryApi from "../../api/moudles/gallery";
import { mapState, mapMutations } from "vuex";
import { resolve } from "path";
export default {
  data() {
    return {
      userId: JSON.parse(localStorage.getItem("userInfo")).userId,
      ruleForm: {
        layoutName: "",
        layoutImageUrl: "",
        groupId: "",
        printingPositionInstructions: "",
        createUser: JSON.parse(localStorage.getItem("userInfo")).userId,
        standardPatternPrintImagesList: [],
      },
      rules: {
        layoutName: [
          { required: true, message: this.$t("other.a3363"), trigger: "blur" },
        ],
        layoutImageUrl: [
          { required: true, message: this.$t("other.a3366"), trigger: "blur" },
        ],
        groupId: [{ required: true, message: "请选择分组", trigger: "blur" }],
      },
      token: {
        token: JSON.parse(localStorage.getItem("userInfo")).token,
      },
      imageUrl: "",
      pathUrl: "",
      options: [],
      showMatch: false,
      uploadIndex: 0,
      standardPatternId: "",
      mathList: [],
      pathType: "",
    };
  },

  components: {
    CustomerOrder,
  },

  inject: ["reload"],

  computed: {
    //这一部分直接拿过来用的
    ...mapState({
      ModelData: (state) => state.common.ModelData,
    }),
  },

  watch: {},

  created() {
    this.init();
  },

  methods: {
    openMatch() {
      let arr = [];
      this.ruleForm.standardPatternPrintImagesList.forEach((v) => {
        let str = v.skuName + "-" + v.cusCode + "-" + v.variationName;
        arr.push(str);
      });
      this.mathList = arr;
      this.showMatch = true;
    },
    init() {
      this.getSelData();
      this.pathUrl = JSON.parse(this.$route.query.from);
      this.pathType =
        this.pathUrl.indexOf("/gallery/galleryHeatMap") !== -1
          ? "galleryHeatMap"
          : "galleryStandard";
      if (this.$route.query.standardPatternId) {
        this.standardPatternId = this.$route.query.standardPatternId;
        galleryApi
          .getStandardPatternDetail(this.userId, this.standardPatternId)
          .then((res) => {
            console.log(res);
            console.log("====7777");
            if (res.code === 200) {
              this.ruleForm = res.data;
              this.imageUrl = res.data.layoutImageUrl;
              let arr = [];
              this.ruleForm.standardPatternPrintImagesList.forEach((v) => {
                let str = v.skuName + "-" + v.cusCode + "-" + v.variationName;
                arr.push(str);
              });
              this.mathList = arr;
            } else {
              this.$message.warning(res.msg);
            }
          });
      }
    },

    getSelData() {
      galleryApi.getStandardPatternPrintGroupsList(this.userId).then((res) => {
        console.log(res);
        console.log("====12121s");
        if (res.code === 200) {
          this.options = res.data;
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    cancel() {
      this.$router.push(this.pathUrl);
    },
    handleSuccess(rows, index, res, file) {
      console.log(file.response.data);
      console.log(index);
      rows[index].imageUrl = file.response.data;
      console.log(this.ruleForm.standardPatternPrintImagesList);
    },
    handleAvatarSuccess(res, file) {
      console.log(file.response.data);
      this.imageUrl = URL.createObjectURL(file.raw);
      this.ruleForm.layoutImageUrl = file.response.data;
      console.log(this.ruleForm);
    },
    beforeAvatarUpload(file) {
      console.log(file);
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;
    },
    beforeAvatarUploadDPI(file) {
      console.log(file, "file");
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;
      // return new Promise(async (resolve, reject) => {
      //   try {
      //     //       // 原生二进制解析，无第三方依赖
      //     const { dpiX, dpiY } = await this.getImageDpiNative(file);
      //     console.log("原生解析DPI", dpiX, dpiY);
      //     const minDpi = 150;
      //     // 无DPI数据 / 任一轴不足阈值 直接拦截
      //     if (
      //       dpiX === undefined ||
      //       dpiY === undefined ||
      //       dpiX != minDpi ||
      //       dpiY != minDpi
      //     ) {
      //       let textNum = dpiX != minDpi ? dpiX : dpiY != minDpi ? dpiY : 72;
      //       if (dpiX === undefined || dpiY === undefined) {
      //         textNum = 72;
      //       }
      //       console.log(textNum);
      //       let text =
      //         this.$t("other.a3422") + textNum + this.$t("other.a3423");
      //       // this.$alert(text, this.$t('other.a142'), {
      //       //     confirmButtonText: this.$t('other.a5'),
      //       // });
      //       reject(false);
      //       return;
      //     }
      //     resolve(true);
      //   } catch (err) {
      //     console.error("原生解析图片失败", err);
      //     this.$message.warning("读取图片分辨率失败，禁止上传");
      //     reject(false);
      //   }
      // });
    },
    /**
     * 原生解析图片DPI，无第三方库
     * @param {File} file 图片文件
     * @returns {Promise<{dpiX: number|undefined, dpiY: number|undefined}>}
     */
    getImageDpiNative(file) {
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = (e) => {
          const buf = new Uint8Array(e.target.result);
          // JPG解析
          if (this.isJpg(buf)) {
            const dpi = this.parseJpgDpi(buf);
            resolve(dpi);
            return;
          }
          // PNG解析
          if (this.isPng(buf)) {
            const dpi = this.parsePngDpi(buf);
            resolve(dpi);
            return;
          }
          // 非jpg/png 无DPI数据
          resolve({ dpiX: undefined, dpiY: undefined });
        };
        reader.readAsArrayBuffer(file);
      });
    },

    // 判断JPG文件
    isJpg(buf) {
      return buf[0] === 0xff && buf[1] === 0xd8 && buf[2] === 0xff;
    },
    // 判断PNG文件
    isPng(buf) {
      return (
        buf[0] === 0x89 && buf[1] === 0x50 && buf[2] === 0x4e && buf[3] === 0x47
      );
    },

    // JPG 解析JFIF + EXIF 双渠道DPI（重写完整版）
    parseJpgDpi(buf) {
      let offset = 2;
      const len = buf.length;
      let dpiX, dpiY;

      while (offset < len - 4) {
        const markerHigh = buf[offset];
        const markerLow = buf[offset + 1];
        const segLen = (buf[offset + 2] << 8) | buf[offset + 3];

        // 1. 优先解析JFIF标记 0xFFE0（截图/网页图DPI存在这里，你当前图片缺失EXIF分辨率靠这段读取）
        if (markerHigh === 0xff && markerLow === 0xe0) {
          // 校验JFIF头部标识 JFIF\0
          const headerStr = String.fromCharCode(
            buf[offset + 4],
            buf[offset + 5],
            buf[offset + 6],
            buf[offset + 7]
          );
          if (headerStr === "JFIF") {
            const unit = buf[offset + 11]; // 1=英寸 2=厘米
            let xRaw = this.read16(buf, offset + 12, false);
            let yRaw = this.read16(buf, offset + 14, false);
            // 厘米转英寸DPI
            if (unit === 2) {
              xRaw = Math.round(xRaw * 2.54);
              yRaw = Math.round(yRaw * 2.54);
            }
            dpiX = xRaw;
            dpiY = yRaw;
          }
          offset += 2 + segLen;
          continue;
        }

        // 2. 原有EXIF标记 0xFFE1 解析逻辑（修复提前return，兼容type3/type5）
        if (markerHigh === 0xff && markerLow === 0xe1) {
          const exifStart = offset + 4;
          // 跳过"Exif\0\0"头部 6字节
          const tiffStart = exifStart + 6;
          const byteOrder = buf[tiffStart];
          const isLittle = byteOrder === 0x49; // II小端
          let tagOffset = tiffStart + 2;
          const tagCount = this.read16(buf, tagOffset, isLittle);
          tagOffset += 2;

          // 遍历全部标签，不提前退出循环
          for (let i = 0; i < tagCount; i++) {
            const tag = this.read16(buf, tagOffset, isLittle);
            // XResolution=0x011A YResolution=0x011B
            if (tag === 0x011a || tag === 0x011b) {
              const type = this.read16(buf, tagOffset + 2, isLittle);
              const valOff = this.read32(buf, tagOffset + 8, isLittle);
              let dpiVal;
              // 类型5：RATIONAL 有理数（分子/分母，相机原图）
              if (type === 5) {
                const num = this.read32(buf, exifStart + valOff, isLittle);
                const den = this.read32(buf, exifStart + valOff + 4, isLittle);
                dpiVal = Math.round(num / den);
              }
              // 类型3：SHORT 短整数（部分软件直接存数字DPI）
              else if (type === 3) {
                dpiVal = this.read16(buf, tagOffset + 8, isLittle);
              }
              // 赋值对应分辨率
              if (dpiVal != null) {
                if (tag === 0x011a) dpiX = dpiVal;
                if (tag === 0x011b) dpiY = dpiVal;
              }
            }
            tagOffset += 12;
          }
          break; // EXIF段只存在一段，解析完成跳出循环
        }

        // 下一个分段偏移
        offset += 2 + segLen;
      }

      // 保持原有返回结构，无数据返回undefined
      return { dpiX, dpiY };
    },

    // PNG 解析pHYs块获取像素每米，换算DPI（完全保留你原有代码无修改）
    parsePngDpi(buf) {
      let offset = 8; // PNG头部8字节
      const len = buf.length;
      while (offset < len - 12) {
        const chunkLen = this.read32(buf, offset, false);
        const chunkType = String.fromCharCode(
          buf[offset + 4],
          buf[offset + 5],
          buf[offset + 6],
          buf[offset + 7]
        );
        if (chunkType === "pHYs") {
          const pxPerMeterX = this.read32(buf, offset + 8, false);
          const pxPerMeterY = this.read32(buf, offset + 12, false);
          const dpiX = Math.round(pxPerMeterX * 0.0254);
          const dpiY = Math.round(pxPerMeterY * 0.0254);
          return { dpiX, dpiY };
        }
        offset += 4 + 4 + chunkLen + 4;
      }
      return { dpiX: undefined, dpiY: undefined };
    },

    // 读取16位数值（完全保留你原有实现，不改动）
    read16(buf, off, little) {
      return little
        ? (buf[off + 1] << 8) | buf[off]
        : (buf[off] << 8) | buf[off + 1];
    },
    // 读取32位数值（完全保留你原有实现，不改动）
    read32(buf, off, little) {
      return little
        ? (buf[off + 3] << 24) |
            (buf[off + 2] << 16) |
            (buf[off + 1] << 8) |
            buf[off]
        : (buf[off] << 24) |
            (buf[off + 1] << 16) |
            (buf[off + 2] << 8) |
            buf[off + 3];
    },

    updataItem(data) {
      console.log(data);
      // let arr = []
      // this.ruleForm.standardPatternPrintImagesList.forEach(v => {
      //     let strV = v.skuName + '-' + v.cusCode + '-' + v.variationName
      //     data.forEach(p => {
      //         let strP = p.skuName + '-' + p.cusCode + '-' + p.variationName
      //         if(strV != strP){

      //         }
      //     })
      // })

      data.forEach((p) => {
        let str = p.skuName + "-" + p.cusCode + "-" + p.variationName;
        let index = this.mathList.indexOf(str);
        if (index != -1) {
          p.imageUrl =
            this.ruleForm.standardPatternPrintImagesList[index].imageUrl;
        }
      });
      this.ruleForm.standardPatternPrintImagesList = data;
      console.log("===1222");
    },

    deleteRow(index, rows) {
      rows.splice(index, 1);
    },

    saveItem() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          if (this.ruleForm.standardPatternPrintImagesList.length == 0) {
            this.$message.warning("请匹配实物");
            return;
          }
          for (
            let i = 0;
            i < this.ruleForm.standardPatternPrintImagesList.length;
            i++
          ) {
            if (!this.ruleForm.standardPatternPrintImagesList[i].imageUrl) {
              this.$message.warning("请上传打印图片");
              return;
            }
          }
          if (this.standardPatternId == "") {
            galleryApi.addStandardPattern(this.ruleForm).then((res) => {
              if (res.code === 200) {
                this.$message.success(this.$t("other.a2623"));
                setTimeout(() => {
                  this.cancel();
                }, 800);
              } else {
                this.$message.warning(res.msg);
              }
            });
          } else {
            this.ruleForm.id = this.standardPatternId;
            galleryApi.editStandardPattern(this.ruleForm).then((res) => {
              if (res.code === 200) {
                this.$message.success(this.$t("other.a2623"));
                setTimeout(() => {
                  this.cancel();
                }, 800);
              } else {
                this.$message.warning(res.msg);
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>
  
<style lang="scss" scoped>
@import "~@assets/scss/mixins";

.createStoreProdcut {
  // flex:1;
  // margin: 50px 0 0 223px;

  background-color: #eee;
  box-sizing: border-box;
  padding: 0 20px;
  margin-bottom: 60px;

  .footer {
    position: fixed;
    background-color: #fff;
    width: 86%;
    bottom: 0;
    height: 70px;
    margin-left: -20px;
    border-top: 1px solid #eee;
    z-index: 15;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    box-shadow: 5px ​4px 23px -6px #606266;
  }

  .basic_info {
    background-color: #fff;
    padding: 0 16px;
    margin-bottom: 25px;

    .attribute {
      display: inline-block;
      min-width: 350px;
      box-sizing: border-box;
      margin-bottom: 10px;

      .attribute_desc {
        display: inline-block;
        width: 150px;
        text-align: right;
      }
    }

    .title {
      height: 68px;
      line-height: 68px;
      font-size: 20px;
      font-weight: 500;
      letter-spacing: 0.02em !important;
      font-family: Roboto, sans-serif !important;
      border-bottom: 1px solid #eee;
    }

    .basic_detail {
      padding: 15px 0;

      .singSku_wrapper {
        display: flex;

        .singSku {
          display: flex;
          margin-right: 30px;

          .inputBox {
            display: inline-block;
            width: 180px;
          }
        }
      }
    }

    .listitem {
      display: inline-block;
      width: 120px;
      height: 120px;
      border-radius: 3px;
      cursor: pointer;
      border: 1px dashed #c0ccda;
      margin: 0 5px;
      position: relative;
    }

    .pic_desc {
      position: absolute;
      bottom: -45px;
      left: 40px;
    }

    .cateGory_wrapper {
      position: relative;
      box-shadow: 0 5px 5px -3px #606266;
      height: 450px;

      .first_wrapper {
        position: absolute;
        top: 0;
        left: 0;
        width: 350px;
        height: 450px;
        overflow-y: scroll;
        z-index: 99;
        background-color: #fff;

        .first_category {
          cursor: pointer;
          padding: 0 10px;
          border-bottom: 1px solid #eee;
        }
      }

      .second_wrapper {
        position: absolute;
        top: 0;
        left: 350px;
        width: 350px;
        height: 450px;
        overflow-y: scroll;
        z-index: 99;
        background-color: #fff;

        .second_category {
          cursor: pointer;
          padding: 0 10px;
          border-bottom: 1px solid #eee;
        }
      }

      .three_wrapper {
        position: absolute;
        top: 0;
        left: 700px;
        width: 350px;
        height: 450px;
        overflow-y: scroll;
        z-index: 99;
        background-color: #fff;

        .three_category {
          cursor: pointer;
          padding: 0 10px;
          border-bottom: 1px solid #eee;
        }
      }

      .four_wrapper {
        position: absolute;
        top: 0;
        left: 1050px;
        width: 350px;
        height: 450px;
        overflow-y: scroll;
        z-index: 99;
        background-color: #fff;

        .four_category {
          cursor: pointer;
          padding: 0 10px;
          border-bottom: 1px solid #eee;
        }
      }

      .category_title {
        position: relative;
        top: 0;
        left: 0;
      }

      .active:hover {
        background-color: #eee;
      }
    }

    .pic_box {
      width: 120px;
      height: 120px;
      position: absolute;
      z-index: 2;
    }

    .listitem::after {
      content: "+";
      font-size: 40px;

      position: absolute;
      top: 48px;
      left: 48px;
      z-index: 1;
    }

    .delete {
      width: 120px;
      background-color: rgba(0, 0, 0, 0.87);
      color: #fff;
      position: absolute;
      bottom: 0;
      left: 0;
      text-align: center;
      display: none;
      z-index: 99;
    }

    .deleteActive {
      display: block;
      z-index: 99;
    }

    .icon-zengjiatianjiajiajian {
      color: rgb(64, 211, 242);
      cursor: pointer;
      font-size: 20px;
    }

    .icon-jianshao1 {
      color: rgb(246, 97, 109);
      cursor: pointer;
      font-size: 20px;
    }
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 120px;
    height: 120px;
    line-height: 120px;
    text-align: center;
    border: 1px dashed #66b1ff;
  }

  .avatar {
    width: 120px;
    height: 120px;
    display: block;
  }
}

.cTitle {
  font-size: 20px;
}

.cLi {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.cLi .label {
  width: 120px;
}

.cLi .el-input {
  margin-right: 10px;
}
</style>